<template>
    <div class="PostImagesUpload">
        <el-button
                type="primary"
                size="mini"
                class="mb-4"
                @click.prevent.native="handleAddClick"
                :disabled="desactiverChamp"
        >{{ $t("posts.components.picturesButton") }}
        </el-button>

        <el-dialog class="PostImagesUpload-dialog" :visible="dialogVisible" @close="closeDialog()">
            <h3 slot="title">{{ $t("posts.components.picturesDialogTitle") }}</h3>
            <el-row
                    :gutter="44"
                    class="PostImagesUpload-container"
                    :type="browserContext.up('md') ? 'flex' : null"
            >
                <el-col :lg="24" class="pb-3">
                    <p>{{ $t("posts.components.picturesDialogTextTop") }} :</p>
                    <el-upload
                            action=""
                            class="upload-demo"
                            drag
                            :on-change="handleFileSelect"
                            :auto-upload="false"
                            multiple
                            :file-list="fileList"
                            :limit="maximumPhotosAuthorizedToUpload"
                    >
                        <em class="el-icon-upload"></em>
                        <div class="el-upload__text" v-html="$t('posts.components.picturesDialogTextMiddle')"/>
                        <div class="el-upload__tip" slot="tip" v-html="$t('posts.components.picturesDialogTextBottom')"/>
                    </el-upload>
                </el-col>
            </el-row>

            <div class="PostImagesUpload-actions">
                <el-button @click.prevent.native="dialogVisible = false">
                    {{ $t("posts.components.picturesButtonCancel") }}
                </el-button>
                <el-button @click.prevent.native="addImages" type="primary">
                    {{ $t("posts.components.picturesButtonAdd") }}
                </el-button>
            </div>
        </el-dialog>

<!--        TODO: check https://sortablejs.github.io/Vue.Draggable/#/transition-example-2 to improve design-->
        <el-row :gutter="50">
            <draggable :list="post.photos" group="people" @start="drag=true" @end="drag=false" v-bind="dragOptions" @change="onChange">
                <el-col :span="8" v-for="photo in post.photos" :key="photo.url" style="padding-bottom: 20px"  v-if="photo != undefined">
                    <ubi-card :published="true" full-width>
                        <img :key="photo.url" :src="photo.url" height="215" alt="" />
                        <template slot="footer">
                            <el-button type="danger" size="mini" @click.prevent.native="handleRemove(photo)" :disabled="desactiverChamp">
                                {{ $t("posts.components.picturesButtonDelete") }}
                            </el-button>
                        </template>
                    </ubi-card>
                </el-col>
            </draggable>
        </el-row>
    </div>
</template>

<style lang="scss">
    @import "@/theme/_bootstrap.scss";

    .PostImagesUpload {
        &-dialog .el-dialog {
            width: 670px;
            max-width: 90%;
        }

        &-container {
            > *:not(:first-child) {
                border-left: 1px solid $gray-200;
            }
        }

        &-actions {
            text-align: right;
        }
    }

    .button {
        margin-top: 35px;
    }
    .flip-list-move {
        transition: transform 0.5s;
    }
    .no-move {
        transition: transform 0s;
    }
    .ghost {
        opacity: 0.5;
        background: #c8ebfb;
    }
    .list-group {
        min-height: 20px;
    }
    .list-group-item {
        cursor: move;
    }
    .list-group-item i {
        cursor: pointer;
    }
</style>

<script>
import { Dialog, Upload } from 'element-ui'
import draggable from 'vuedraggable'

export default {
  name: 'PostImagesUpload',
  inject: ['browserContext'],
  components: { ElDialog: Dialog, ElUpload: Upload, draggable },
  props: ['desactiverChamp', 'post', 'value', 'selected'],
  data () {
    return {
      file: '',
      fileList: [],
      dialogVisible: false
    }
  },
  methods: {
    handleAddClick (event) {
      this.dialogVisible = true
    },
    handleFileSelect (file, fileList) {
      // if file size is less than 10Mo and formated to jpg/jpeg/png
      if (file.size <= 10000000 && (file.raw.type === 'image/png' || file.raw.type === 'image/jpeg')) {
        this.fileList.push(file)
      } else {
        this.closeDialog()
        const format = file.raw.type.replace('image/', '')
        this.$message({ message: this.$t('error.formatImage', { format: format }), type: 'error' })
      }
    },
    closeDialog () {
      this.dialogVisible = false
    },
    addImages () {
      const self = this
      const pointeur = self.post.photos.length

      Array.prototype.forEach.call(this.fileList, function (file, index) {
        const previewReader = new FileReader()

        previewReader.onload = function (readerEvt) {
					const newPhoto = { type: 'base64', url: readerEvt.target.result }
          if (!self.post.photos) {
            self.post.photos = []
          }
          self.post.photos[pointeur + index] = newPhoto
          self.$forceUpdate()
        }

        previewReader.readAsDataURL(file.raw)
      })

      this.dialogVisible = false
      this.fileList = []
    },
    handleRemove (photo) {
      this.post.photos.splice(this.post.photos.findIndex(v => v.url === photo.url), 1)
      this.$forceUpdate()
    },
    onChange () {
      this.$forceUpdate()
    }
  },
  computed: {
    dragOptions () {
      return {
        animation: 0,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost'
      }
    },
    maximumPhotosAuthorizedToUpload () {
      if (this.post.photos) {
        return 50 - this.post.photos.length
      } else {
        return 50
      }
    }
  },
  beforeMount () {
		    if (!this.post.photos) {
		        this.post.photos = []
    }
  }
}
</script>
